<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%;"
  >
  
    <div  v-for="(item, index) in __list" :class="styleSublisteMode+isCurrent(index === __idxOnEdition || item._id === showSubID)" :key="index">
      <button
        v-if="__preview"
        type="button"
        :class="(__current===item.name) ? 'setViewActif': 'setView'"
        @click="__customCB(item.name)"
      >
        <span class="optionStateRail" :class="item.isActive == true ? 'optionStateRail-on' : 'optionStateRail-off'"></span>
        <span>{{ item.name}}</span>
      </button>
      <div v-if="!__preview" class="optionInlineRow">
        <button type="button" class="subPreview" @click= "toggleMenu(index)">
          <span class="optionStateRail" :class="item.isActive == true ? 'optionStateRail-on' : 'optionStateRail-off'"></span>
          <span>{{ item.name}}</span>
        </button>

        <div class="subMenu" v-if="showMenu === index && !__preview">
          <ico-btn size="p" type="simple" icone="gear-fill" :cb="()=>{dispatchEdit(item._id)}"></ico-btn>
          <ico-btn size="p" type="toggleOn" custom="orange" icone="eye-slash-fill" v-if=" item.isActive == true" :cb="()=>{dispatchDesactive(item._id)}"></ico-btn>
          <ico-btn size="p" type="toggleOff" icone="eye-fill" v-if=" item.isActive == false" :cb="()=>{dispatchActive(item._id)}"></ico-btn>
          <ico-btn size="p" type="warning" icone="trash" :cb="()=>{dispatchDelete(item._id)}" v-if="__editMode == false"></ico-btn>
          <ico-btn size='p' type="simple" icone="list-stars" :cb="()=>{showSub(item._id)}" v-if="__type == 'EXT_DD'"></ico-btn>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";
export default {
  components: {
  },
  props: {
    __current: {
      type: String,
      default: () => {
        return '';
      },
    },
    __preview: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __customCB: {
      type: Function,
      default: () => {
        return ()=>{};
      },
    },
    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __type: {
      type: String,
      default: () => {
        return 'DD';
      },
    },
  },
  
  data() {
    return {
      showMenu: -1,
      showSubID: null,
    };
  },
  methods: {    
    showSub(id) {
      if(id === this.showSubID) {
        this.showSubID = null;
        this.$parent.showSub(null);
        return
      }
      this.showSubID = id;
      this.$parent.showSub(id);

    },

    isCurrent(current) {
      return current && this.__editMode ? ' actif' : '';
    },

    toggleMenu(index) {
      if(this.showMenu != index ){this.showMenu = index} else {this.showMenu =-1}
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    dispatchActive(idx) {
      this.$parent.toggleActivateAction(idx,1);
    },

    dispatchDesactive(idx) {
      this.$parent.toggleActivateAction(idx,0);
    },

    dispatchDelete(idx) {
      this.$bvModal.msgBoxConfirm('Veuillez confirmer la suppression.', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Confirmer',
        cancelTitle: 'Annuler',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: false
      })
        .then(value => {
          if(value) {
            this.$parent.deleteAction(idx);
          }
        })
    },

    dispatchAdd() {
      this.$parent.addAction();
    },

  },

  computed: {
    styleSublisteMode() {
      return (this.__idxOnEdition !== -1) ? 'sublisteModeFull' : 'sublisteMode';
    },
  },

  watch: {
    __isOnLoad: function () {
    },
  },
};
</script>
<style scoped>
.actif{
  opacity: 1 !important;
}
.sublisteModeFull {
  width: 100%;
  float: left;
  margin-bottom: 12px;
  padding: 4px;
  border-radius: 18px;
  border: 1px solid #dbe4f0;
  opacity: 0.3;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}
.sublisteModeFull .subMenu {
  width: auto;
  margin-left: auto;
  padding: 8px 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.sublisteModeFull .subPreview {
  flex: 1 1 auto;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}
.sublisteMode {
    width: 100%;
    float: left;
    margin-bottom: 12px;
    padding: 4px;
    border-radius: 18px;
    border: 1px solid #dbe4f0;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    display: flex;
    align-items: center;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}
.sublisteMode .subMenu {
    width: auto;
    margin-left: auto;
    padding: 8px 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.sublisteMode .subPreview {
    flex: 1 1 auto;
    padding: 12px 14px;
    border-radius: 14px;
    font-size: 13px;
    font-weight: 700;
    color: #1e2a44;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    appearance: none;
    border: 0;
    background: transparent;
    text-align: left;
    font-family: inherit;
}

.sublisteMode:hover {
  transform: translateY(-1px);
  border-color: #c9d8eb;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
}

.setViewActif{
  width: 100%;
  float: left;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 12px;
  border: 1px solid rgba(21, 128, 61, 0.22);
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.08) 0%, rgba(255, 255, 255, 0.98) 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  text-align: left;
}

.setView{
  width: 100%;
  float: left;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 12px;
  border: 1px solid rgba(220, 38, 38, 0.16);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  text-align: left;
}

.optionInlineRow {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.optionStateRail {
  flex: 0 0 auto;
  width: 6px;
  min-height: 34px;
  border-radius: 999px;
}

.optionStateRail-on {
  background: linear-gradient(180deg, #16a34a 0%, #15803d 100%);
}

.optionStateRail-off {
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
}
@media (max-width: 768px) {
  .sublisteMode,
  .sublisteModeFull {
    flex-direction: column;
    align-items: stretch;
  }

  .sublisteMode .subMenu,
  .sublisteModeFull .subMenu {
    width: 100%;
    margin-left: 0;
    justify-content: flex-end;
  }

  .optionInlineRow {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
